import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteUnavailabilityPayload {
    id: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IDeleteUnavailabilityState {
    status: string
    data: any
    errors: any
}

const initialState: IDeleteUnavailabilityState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteUnavailability = createSlice({
    name: 'meeting/delete-unavailability',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteUnavailabilityPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteUnavailabilityActions = deleteUnavailability.actions
export default deleteUnavailability.reducer
